module.exports = function() {};



// WEBPACK FOOTER //
// ./src/utils/noop.js


// WEBPACK FOOTER //
// webpack:///src/utils/noop.js